// The non-null assertions are acceptable because there definitely will always
// be data in the successful responses where the non-null assertions are made.
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/dist/query';
import { BaseQueryFn } from '@reduxjs/toolkit/dist/query/baseQueryTypes';
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';
import { BigCommerceEndpointTagTypes, JimboResponse, PriceListWithRecords } from '@models';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const priceListEndpoints = (
  builder: EndpointBuilder<
    // eslint-disable-next-line @typescript-eslint/ban-types
    BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>,
    BigCommerceEndpointTagTypes,
    'bigCommerceApi'
  >,
) => {
  return {
    getAllPriceLists: builder.query<PriceListWithRecords[], void>({
      query: () => 'pricelists',
      providesTags: ['PriceList'],
      transformResponse: (response: JimboResponse<PriceListWithRecords[]>) => response.data!,
    }),

    upsertPriceListRecords: builder.mutation<JimboResponse, PriceListWithRecords[]>({
      query: (priceLists) => ({
        url: 'pricelists/records',
        method: 'PUT',
        body: priceLists,
      }),
      invalidatesTags: ['PriceList'],
    }),

    deletePriceListRecords: builder.mutation<JimboResponse, { priceListId: number; recordIds: number[] }[]>({
      query: (body) => ({
        url: 'pricelists/records',
        method: 'DELETE',
        body,
      }),
      invalidatesTags: ['PriceList'],
    }),
  };
};
